import { NgModule } from '@angular/core';
import { DatepickerCustomHeaderComponent } from './datepicker-custom-header.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule
    ],
    declarations: [
        DatepickerCustomHeaderComponent
    ],
    exports: [
        DatepickerCustomHeaderComponent
    ]
})
export class DatepickerCustomHeaderModule { }
